// extracted by mini-css-extract-plugin
export default {"container":"barChartGrouped_container__mgRAA"};